import { toJalaliDate } from '../../utils/dateUtils';

const RequestRow = ({ title, creator_name, description, created_at, flows }) => {
  const receiverCount = flows?.length || 0;
  return (
    <div className="bg-white p-4 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-all mb-3 text-right">
      <div className="flex flex-row-reverse justify-between items-center mb-3">
        {receiverCount > 1 ? (
          <span className="text-[10px] font-bold text-indigo-600 bg-indigo-50 px-2 py-1 rounded-full">
            {receiverCount} گیرنده
          </span>
        ) : (
          <span className="text-slate-400 cursor-pointer text-xl">...</span>
        )}
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-xs font-bold text-indigo-600 border border-slate-200">
            {creator_name?.charAt(0) || "؟"}
          </div>
          <span className="text-sm font-bold text-slate-800">{title}</span>
        </div>
      </div>
      <p className="text-xs text-slate-500 leading-5 mb-4 text-right">{description}</p>
      <div className="text-[10px] text-slate-400 font-bold text-left">{toJalaliDate(created_at)}</div>
    </div>
  );
};

export default RequestRow;